import dayjs from "dayjs";

export const getFiscalYear = (value?: string): string => {
  // If the month is before August, return the previous year
  if (Number(dayjs(value).format('M')) < 8) {
    return dayjs(value).subtract(1, 'year').format('YYYY');
  } else {
    return dayjs(value).format('YYYY');
  }
}